var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-stage',{ref:"stage",attrs:{"config":_vm.stageSize},on:{"mousedown":_vm.handleStageMouseDown}},[_c('v-layer',{ref:"layer"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }